import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ResponsiveService } from '@frk/eds-components';
import { BaseTableResponsiveComponent } from '@shared/table/base-table-responsive.component';
import {
  DateRange,
  FundId,
  FundPerformanceDates,
  FundPerformanceDiscreteReturnsStateConfig,
  FundPerformanceDiscreteReturnsTableData,
} from '@types';

@Component({
  selector: 'ft-fund-performance-discrete-returns-table',
  templateUrl: './fund-performance-discrete-returns-table.component.html',
  styleUrls: ['./fund-performance-discrete-returns-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundPerformanceDiscreteReturnsTableComponent
  extends BaseTableResponsiveComponent
  implements OnInit {
  @Input() fundPerformanceData: FundPerformanceDiscreteReturnsTableData[];
  @Input() fundPerformanceConfig: FundPerformanceDiscreteReturnsStateConfig;
  @Input() fundPerformanceDates: FundPerformanceDates;
  @Input() tableLabel: string;
  @Input() years: DateRange[];
  @Input() tableCols: string[];
  @Input() fundId: FundId;
  @Input() isAllShareClasses = false;

  constructor(protected responsiveService: ResponsiveService) {
    super(responsiveService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
